import React from "react";
import Link from "next/link"
import { Container, Row, Col, Badge } from "react-bootstrap"
import footerContent from "../data/footer.json"

//
const Footer = () => {

  const mainFooterContent = footerContent.mainContent;
  const privaciesData = footerContent.privacies;

  return (
    <footer className="position-relative z-index-10 d-print-none">
      < div className="py-6 fw-light bg-gray-900 text-gray-300">
        <Container>
          <Row>
            {mainFooterContent &&
              mainFooterContent.map((item) => (
                <Col
                  key={item.title}
                  lg={item.lg && item.lg}
                  md={item.md && item.md}
                  className="mb-5 mb-lg-0"
                >
                  <div className="fw-bold text-uppercase  mb-3">
                    {item.title}
                  </div>
                  {item.links && (
                    <ul className="list-unstyled ">
                      {item.links.map((link) => (
                        <li key={link.title}>
                          <Link
                            href={link.link}
                            className="text-gray-600"
                            rel={link.link.startsWith("/auth/") ? "nofollow" : undefined}
                          >
                            {link.title}
                            {link.new && (
                              <Badge variant="info" bg="info-light" className="ml-1">
                                New
                              </Badge>
                            )}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  )}
                  {item.social && (
                    <ul className="list-inline">
                      {item.social.map((socialIcon) => (
                        <li key={socialIcon.title} className="list-inline-item">
                          <a
                            href={socialIcon.link}
                            rel="nofollow noopener noreferrer"
                            target="_blank"
                            title={socialIcon.title}
                            className="text-light-emphasis text-hover-primary "
                          >
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-linkedin">
                              <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
                              <rect width="4" height="12" x="2" y="9" />
                              <circle cx="4" cy="4" r="2" />
                            </svg>
                          </a>
                        </li>
                      ))}
                    </ul>
                  )}
                </Col>
              ))}
          </Row>
        </Container>
        <div className="border-top border-dark p-2"></div>
        <Container>
          <Row >
            <div className="d-flex gap-3 flex-column flex-md-row">
              <span>{`© ${new Date().getFullYear()} VendorLand. All rights reserved.`}</span>
              {privaciesData &&
                <div className="d-flex">
                  {privaciesData.map((privacy) =>
                    <Link href={privacy.link} key={privacy.title} className="text-gray-600">
                      {privacy.title}
                    </Link>)}
                </div>
              }
            </div>
          </Row>
        </Container>
      </div>
    </footer>
  )
}

export default Footer
